import { NgModule } from "@angular/core"
import { AboutBlockHeaderComponentModule } from "@component/profile/about-block-header/about-block-header.component";
import { ProfileAboutComponent } from '@component/profile/profile-about/profile-about.component'
import { ProfileNavComponent } from '@component/profile/profile-nav/profile-nav.component'
import { ProfileHeaderComponentModule } from '@component/profile/profile-header/profile-header.component'
import { ProfileBoniComponent } from '@component/profile/profile-boni/profile-boni.component'
import { SharedModule } from "./shared.module";
import { ProfileStatisticsComponent } from "@component/profile/profile-statistics/profile-statistics.component";
import { LevelProgressBarComponent } from "@component/profile/level-progress-bar/level-progress-bar.component";
import { ProfileSettingsComponent } from "@component/profile/profile-settings/profile-settings.component";
import { CreateCompanyProfileComponent } from '@component/profile/create-company-profile/create-company-profile.component'
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ImageUploadBoxComponentModule } from "@component/generic/image-upload-box/image-upload-box.component";
import { EditImagesComponentModule } from "@component/generic/edit-images/edit-images.component";
import { MatStepperModule } from "@angular/material/stepper";
import { MatExpansionModule } from "@angular/material/expansion";
import { MyContentComponent } from "@component/profile/my-content/my-content.component";
import { ContentPreviewComponent } from "@component/profile/content-preview/content-preview.component";
import { ViewsDisplayModule } from "@component/interaction-buttons/views-display/views-display.component";
import { AuthorComponentModule } from "@component/author/author.component";
import { EnumtranslatePipeModule } from "@pipe/enumtranslate.pipe";
import { MoneyInsertThousandSignsModule } from "@pipe/money-insert-thousand-signs";
import { CompanyComponent } from "@component/profile/company/company.component";
import { BusinessNewProfileComponent } from '@component/profile/business-new-profile/business-new-profile.component'
import { EditorModule } from "@tinymce/tinymce-angular";
import { ChangeMailDialogComponent } from "@modal/change-mail-dialog/change-mail-dialog.component";
import { RouterModule } from "@angular/router";
import { RouterOutletComponent } from "@component/router-outlet-component";
import { ImageSliderComponentModule } from "@component/generic/image-slider/image-slider.component";
import { CompanyProfileComponentModule } from "@component/profile/company-profile/company-profile.component";

@NgModule({
  declarations: [
    ProfileAboutComponent,
    ProfileNavComponent,
    ProfileBoniComponent,
    ProfileSettingsComponent,
    ProfileStatisticsComponent,
    LevelProgressBarComponent,
    CreateCompanyProfileComponent,
    MyContentComponent,
    CompanyComponent,
    ContentPreviewComponent,
    BusinessNewProfileComponent,
    ChangeMailDialogComponent,
  ],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: "about",
        component: ProfileAboutComponent
      },
      {
        path: "boni",
        component: RouterOutletComponent,
        children: [
          {
            path: '',
            component: ProfileBoniComponent,
          },
        ]
      },
      {
        path: "mycontent",
        component: MyContentComponent,
      },
      {
        path: 'business',
        component: CompanyComponent
      },
      {
        path: 'settings',
        component: ProfileSettingsComponent
      }
    ]),
    AboutBlockHeaderComponentModule,
    ProfileHeaderComponentModule,
    ImageUploadBoxComponentModule,
    EditImagesComponentModule,
    ViewsDisplayModule,
    AuthorComponentModule,
    EnumtranslatePipeModule,
    MoneyInsertThousandSignsModule,
    EditorModule,

    MatSelectModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatExpansionModule,

    ImageSliderComponentModule,
    CompanyProfileComponentModule,
  ],
  exports: [
    ProfileAboutComponent,
    ProfileNavComponent,
    ProfileBoniComponent,
    ProfileSettingsComponent,
    ProfileStatisticsComponent,
    LevelProgressBarComponent,
    CreateCompanyProfileComponent,
    MyContentComponent,
    CompanyComponent,
    ContentPreviewComponent,
    BusinessNewProfileComponent,
    CompanyProfileComponentModule,
    ChangeMailDialogComponent,

    SharedModule,
    AboutBlockHeaderComponentModule,
    ProfileHeaderComponentModule,
    ImageUploadBoxComponentModule,
    EditImagesComponentModule,
    ViewsDisplayModule,
    AuthorComponentModule,
    EnumtranslatePipeModule,
    MoneyInsertThousandSignsModule,
    EditorModule,

    MatSelectModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatExpansionModule,
  ]
})
export class ProfileModule { }
